/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon24Regular = forwardRef('SendPaperplaneDiagIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.474 11.119c-1.203-.83-.92-2.68.477-3.112l15.667-4.843c1.344-.415 2.604.845 2.189 2.189L15.963 21.02c-.431 1.396-2.283 1.68-3.112.477l-4.238-6.14-6.14-4.238Zm7.652 3.787 3.96 5.739a.25.25 0 0 0 .445-.068L19.373 4.91a.25.25 0 0 0-.312-.313L3.394 9.44a.25.25 0 0 0-.068.444l5.739 3.961 3.664-3.664a.75.75 0 0 1 1.06 1.06l-3.663 3.665Z" })));
});
